const CONTROLS_PREFIX = 'mplayer-controls';

const LOGO = 'logo';
const VOLTAX_LOGO = 'voltax-logo';
const VOLTAX_LOGO_TOOLTIP = 'voltax-logo-tooltip';
const TITLE = 'title';
const TITLE_TOOLTIP = 'title-tooltip';
const SHARE = 'share';
const CLOSE = 'close';
const PLAY_CIRCLE = 'play-circle';
const PAUSE_CIRCLE = 'pause-circle';
const FULLSCREEN_CIRCLE = 'fullscreen-circle';
const MUTE_CIRCLE = 'mute-circle';
const UNMUTE_CIRCLE = 'unmute-circle';
const PLAY_PAUSE = 'play-pause';
const PLAY_PAUSE_TOOLTIP = 'play-pause-tooltip';
const NEXT = 'next';
const NEXT_TOOLTIP = 'next-tooltip';
const TIME = 'time';
const MUTE = 'mute';
const VOLUME_BAR = 'volume-bar';
const FULLSCREEN = 'fullscreen';
const FULLSCREEN_TOOLTIP = 'fullscreen-tooltip';
const TOP_BAR = 'top-bar';
const BOTTOM_BAR = 'bottom-bar';
const REPLAY_VIDEO = 'replay';
const REPLAY_VIDEO_TOOLTIP = 'replay-tooltip';
const SEEK_BAR = 'seek-bar';
const SEEK_BAR_PROGRESS = 'seek-bar-progress';
const SEEK_BAR_TOOLTIP = 'seek-bar-tooltip';
const SETTINGS_BUTTON = 'settings-button';
const SETTINGS_TOOLTIP = 'settings-tooltip';
const SETTINGS_MENU = 'settings-menu';
const SETTINGS_QUALITY_OPTION = 'settings-quality-option';
const SETTINGS_SPEED_OPTION = 'settings-speed-option';
const SETTINGS_SPEED_LIST = 'settings-speed-list';
const CTA_BUTTON = 'cta-button';
const CTA_ARROW_UP = 'cta-arrow-up';
const CTA_STRING = 'cta-string';
const CTA_DOT = 'cta-dot';
const PARTIAL = 'partial';
const CLOSED_CAPTIONS = 'closed-captions';

export const getLogoId = (playerId: string): string => `${CONTROLS_PREFIX}-${LOGO}-${playerId}`;

export const getVoltaxLogoId = (playerId: string): string => `${CONTROLS_PREFIX}-${VOLTAX_LOGO}-${playerId}`;

export const getVoltaxLogoTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${VOLTAX_LOGO_TOOLTIP}-${playerId}`;

export const getTitleId = (playerId: string): string => `${CONTROLS_PREFIX}-${TITLE}-${playerId}`;

export const getTitleTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${TITLE_TOOLTIP}-${playerId}`;

export const getShareId = (playerId: string): string => `${CONTROLS_PREFIX}-${SHARE}-${playerId}`;

export const getCloseId = (playerId: string): string => `${CONTROLS_PREFIX}-${CLOSE}-${playerId}`;

export const getPlayCircleId = (playerId: string): string => `${CONTROLS_PREFIX}-${PLAY_CIRCLE}-${playerId}`;

export const getPauseCircleId = (playerId: string): string => `${CONTROLS_PREFIX}-${PAUSE_CIRCLE}-${playerId}`;

export const getFullscreenCircleId = (playerId: string): string => `${CONTROLS_PREFIX}-${FULLSCREEN_CIRCLE}-${playerId}`;

export const getMuteCircleId = (playerId: string): string => `${CONTROLS_PREFIX}-${MUTE_CIRCLE}-${playerId}`;

export const getUnmuteCircleId = (playerId: string): string => `${CONTROLS_PREFIX}-${UNMUTE_CIRCLE}-${playerId}`;

export const getPlayAndPauseId = (playerId: string): string => `${CONTROLS_PREFIX}-${PLAY_PAUSE}-${playerId}`;

export const getPlayAndPauseTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${PLAY_PAUSE_TOOLTIP}-${playerId}`;

export const getNextId = (playerId: string): string => `${CONTROLS_PREFIX}-${NEXT}-${playerId}`;

export const getNextTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${NEXT_TOOLTIP}-${playerId}`;

export const getTimeId = (playerId: string): string => `${CONTROLS_PREFIX}-${TIME}-${playerId}`;

export const getMuteId = (playerId: string): string => `${CONTROLS_PREFIX}-${MUTE}-${playerId}`;

export const getVolumeBarId = (playerId: string): string => `${CONTROLS_PREFIX}-${VOLUME_BAR}-${playerId}`;

export const getFullscreenId = (playerId: string): string => `${CONTROLS_PREFIX}-${FULLSCREEN}-${playerId}`;

export const getFullscreenTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${FULLSCREEN_TOOLTIP}-${playerId}`;

export const getTopBarId = (playerId: string): string => `${CONTROLS_PREFIX}-${TOP_BAR}-${playerId}`;

export const getBottomBarId = (playerId: string): string => `${CONTROLS_PREFIX}-${BOTTOM_BAR}-${playerId}`;

export const getReplayVideoId = (playerId: string): string => `${CONTROLS_PREFIX}-${REPLAY_VIDEO}-${playerId}`;

export const getReplayVideoTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${REPLAY_VIDEO_TOOLTIP}-${playerId}`;

export const getSeekBarId = (playerId: string): string => `${CONTROLS_PREFIX}-${SEEK_BAR}-${playerId}`;

export const getSeekBarProgressId = (playerId: string): string => `${CONTROLS_PREFIX}-${SEEK_BAR_PROGRESS}-${playerId}`;

export const getSeekBarTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${SEEK_BAR_TOOLTIP}-${playerId}`;

export const getSettingsButtonId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_BUTTON}-${playerId}`;

export const getSettingsTooltipId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_TOOLTIP}-${playerId}`;

export const getSettingsMenuId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_MENU}-${playerId}`;

export const getSettingsQualityOptionId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_QUALITY_OPTION}-${playerId}`;

export const getSettingsSpeedOptionId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_SPEED_OPTION}-${playerId}`;

export const getSettingsSpeedListId = (playerId: string): string => `${CONTROLS_PREFIX}-${SETTINGS_SPEED_LIST}-${playerId}`;

export const getCtaButtonId = (playerId: string): string => `${CONTROLS_PREFIX}-${CTA_BUTTON}-${playerId}`;

export const getCtaArrowUpId = (playerId: string): string => `${CONTROLS_PREFIX}-${CTA_ARROW_UP}-${playerId}`;

export const getCtaStringId = (playerId: string): string => `${CONTROLS_PREFIX}-${CTA_STRING}-${playerId}`;

export const getCtaDotId = (playerId: string): string => `${CONTROLS_PREFIX}-${CTA_DOT}-${playerId}`;

export const getPartialControlsContainer = (playerId: string): string => `${CONTROLS_PREFIX}-${PARTIAL}-${playerId}`;

export const getClosedCaptionsId = (playerId: string): string => `${CONTROLS_PREFIX}-${CLOSED_CAPTIONS}-${playerId}`;
